// Defining nuskin and nuskin.account namespace (if doesn't exist)
if ('undefined' === typeof window.nuskin){
    window.nuskin = {};
}

if ('undefined' === typeof window.nuskin.newShop) {
    window.nuskin.newShop = {};
}

window.nuskin.site = {};

export default window.nuskin;


//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/namespace.js
// module id = 5
// module chunks = 0